import { initFadeIn } from "./namespace/fadeIn";
import { initSidebarParallax } from "./namespace/sidebarParallax";

document.addEventListener("DOMContentLoaded", () => {
  initFadeIn();
  initSidebarParallax();
});
